import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./AbstractBlock').then(m => ({default: m.AbstractBlock})),
)

export const abstractBlockInfo = B.blockInfo({...meta, Admin, InnerBlock})
